import { serverEndpoints } from "./api";
import { withHeaders } from "./helper.service";

const url = serverEndpoints.gallery;

export const fetchGalleryBlockInfo = () =>
  fetch(url.index, {
    method: "GET",
    headers: withHeaders(),
  })
    .then((res) => res.json())
    .then((json) => json.content.galleryBlock);

export const updateGalleryBlockInfo = (data) =>
  fetch(url.update, {
    method: "POST",
    headers: withHeaders(),
    body: JSON.stringify({ content: data }),
  }).then((res) => res.json());
